export default __webpack_public_path__ + "static/media/rounded-car-2x.f5993b36.webp";